import Paper from '@mui/material/Paper'

const retailStores = [
    {
        value: 'Meijer',
        label: '',
        img: 'images/Grocery/Meijer.svg'
    },
    {
        value: 'Target',
        label: '',
        img: 'images/Grocery/Target.png'
    },
    {
        value: 'Walmart',
        label: '',
        img: 'images/Grocery/Walmart.png'
    },
    {
        value: 'Family Dollar',
        label: '',
        img: 'images/Grocery/FamilyDollar.png'
    },
    {
        value: 'Gordon Foods',
        label: '',
        img: 'images/Grocery/GordonFoods.png'
    },
    {
        value: 'IGA',
        label: '',
        img: 'images/Grocery/IGA.png'
    },
    {
        value: 'Dollar Green',
        label: '',
        img: 'images/Grocery/DollarTree.png'
    },
    {
        value: 'Sams Club',
        label: '',
        img: 'images/Grocery/SamsClub.png'
    },
    {
        value: 'Costco',
        label: '',
        img: 'images/Grocery/Costco.png'
    },
];

export function getStores() {
    return retailStores;
}

    export function getStoreIcons(pickupRequest) {
        let selectedStores = [];
        if (typeof pickupRequest.SelectedStores === 'string') {
            if (pickupRequest.SelectedStores == '') {
                pickupRequest.SelectedStores = [];
            }
            else {
                pickupRequest.SelectedStores = JSON.parse(pickupRequest.SelectedStores);
            }
        }
        if (pickupRequest.SelectedStores.length > 0) {
            if (typeof pickupRequest.SelectedStores === 'string') {
                pickupRequest.SelectedStores = JSON.parse(pickupRequest.SelectedStores);
            }

            for (let i = 0; i < pickupRequest.SelectedStores.length; i++) {
                let storeFound = false;
                for (let j = 0; j < retailStores.length; j++) {
                    let retailStore = retailStores[j];
                    if (retailStore.value === pickupRequest.SelectedStores[i]) {
                        storeFound = true;
                        selectedStores.push(<div key={retailStore.value} style={{ position: 'relative', display: 'flex', flexDirection: 'row', margin: '2px' }}>
                            <Paper elevation={8} style={{ height: '75px', width: '75px', display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', alignSelf: 'center' }}>
                                    <img src={retailStore.img} style={{ maxHeight: '60px', maxWidth: '60px' }} />
                                    <div style={{ alignSelf: 'center' }}>{retailStore.label}</div>
                                </div>
                            </Paper>
                        </div>);
                    }
                }
                if (!storeFound) {
                    selectedStores.push(<div key='unknown_store' style={{ position: 'relative', display: 'flex', flexDirection: 'row', margin: '2px' }}>
                        <Paper elevation={8} style={{ height: '75px', width: '75px', display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: 'white', alignSelf: 'center' }}>
                                
                                <div style={{ alignSelf: 'center' }}>{pickupRequest.SelectedStores[i]}</div>
                            </div>
                        </Paper>
                    </div>);
                }

            }

            return <div style={{ marginTop: '15px', display: 'flex', flexWrap: 'wrap' }}>{selectedStores}</div>
        }

        return [];
    }

